import { IPaymentService } from "../../service/payment/PaymentService";

export default class ValidateTokenInteractor {
  private paymentService: IPaymentService;

  constructor({ paymentService }: { paymentService: IPaymentService }) {
    this.paymentService = paymentService;
  }

  async execute(token: string) {
    return this.paymentService.validateToken(token);
  }
}
